import { render, staticRenderFns } from "./DonutChart.vue?vue&type=template&id=6083d49f&"
import script from "./DonutChart.vue?vue&type=script&lang=js&"
export * from "./DonutChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports